import getMeta from '@atlassian/jira-get-meta';
import { getProductEditions } from '@atlassian/jira-get-meta/src/utils/get-meta-product-editions/index.tsx';

export const getCustomAttributes = () => ({
	...getProductEditions(),
	exposureSource: __SERVER__ ? 'server' : 'client',
});

type WindowStatsigValues = { _statsigValues?: Record<string, unknown> };

const valuesFromGlobal = (() => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const globalVar = (typeof window !== 'undefined' ? window : globalThis) as WindowStatsigValues;
	return {
		locator: () => '_statsigValues' in globalVar,
		processor: () => globalVar._statsigValues,
	};
})();

const valuesFromMeta = (() => {
	// FeatureGate value written into globalThis via SSR. Because statsig is not yet initialised on the client.
	const statsigInitialisationFixesPir24496Enabled =
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
		(globalThis as any).statsigInitialisationFixesPir24496Enabled === true;

	// If parsing fails once, it will always fail. Avoid overhead of parsing again & again.
	let parsingFailed = false;

	const locator = () => {
		if (statsigInitialisationFixesPir24496Enabled === true && parsingFailed) {
			return null;
		}
		return getMeta('ajs-fe-statsig-values');
	};
	return {
		locator,
		processor: () => {
			if (statsigInitialisationFixesPir24496Enabled === true && parsingFailed) {
				throw new Error("Can't parse 'ajs-fe-statsig-values' value");
			}

			const featureFlags = locator();
			if (featureFlags != null && featureFlags !== '') {
				globalThis.performance?.mark?.('statsig-parse:start');
				try {
					const result = JSON.parse(featureFlags);
					globalThis.performance?.mark?.('statsig-parse:end');
					return result;
				} catch {
					if (statsigInitialisationFixesPir24496Enabled === true) {
						parsingFailed = true;
					}
					throw new Error("Can't parse 'ajs-fe-statsig-values' value");
				}
			}
		},
	};
})();

export const _haveValuesArrived = (): boolean => {
	return Boolean(valuesFromGlobal.locator() || valuesFromMeta.locator());
};

export const getGateValues = (): Record<string, unknown> | undefined => {
	if (valuesFromGlobal.locator()) {
		return valuesFromGlobal.processor();
	}
	if (valuesFromMeta.locator()) {
		return valuesFromMeta.processor();
	}
	return undefined;
};
